import {
  ProductTileTakeover,
  TakeoverTilePTT,
  Treatment,
} from '@adapters/prismic/types/plp';
import PTTAsImage from './PTTAsImage';
import PTTOne from './PTTOne';
import PTTTwo from './PTTTwo';
import PTTThree from './PTTThree';
import useObjectVisibility from '@hooks/useObjectVisibility';
import { useEffect, useRef } from 'react';
import {
  InteractionLocation,
  PromotionEventName,
  trackPromotionEvent,
} from '@utils/gtm/ga4/trackPromotionEvents';
import { determinePageType, buildCreativeSlotName } from '@utils/gtm/ga4/utils';

import cn from 'classnames';

import styles from './PTT.module.scss';

export interface PTTProps {
  ptt: Exclude<ProductTileTakeover, TakeoverTilePTT>;
  isPriority: boolean;
}

export function PTT({ ptt, isPriority }: PTTProps) {
  const pttRef = useRef<HTMLElement>(null);

  const isPttVisible = useObjectVisibility(pttRef);

  useEffect(() => {
    if (typeof window !== 'undefined' && isPttVisible) {
      trackPromotionEvent({
        eventName: PromotionEventName.viewPromotion,
        page: {
          path: window.location.pathname,
          page_type: determinePageType(),
        },
        interaction: {
          coop_brand: ptt?.product_tile['co-op_brand_attribute'] || null,
          interaction_location: InteractionLocation.PTT,
        },
        ecommerce:
          ptt.treatment === Treatment.imageOnly
            ? {
                creative_name: `link,${ptt?.product_tile?.urlPath || ''}`,
                creative_slot: buildCreativeSlotName({
                  sliceIndex: ptt?.position,
                  interactionLocation: InteractionLocation.PTT,
                  itemIndex: ptt?.treatment,
                }),
                promotion_id:
                  ptt?.product_tile?.backgroundImage?.alt || 'no alt text',
                promotion_name:
                  ptt?.product_tile?.backgroundImage?.alt || 'no alt text',
                isVideo: false,
              }
            : {
                creative_name: `link,${ptt?.product_tile?.link?.url || ''}`,
                creative_slot: buildCreativeSlotName({
                  sliceIndex: ptt?.position,
                  interactionLocation: InteractionLocation.PTT,
                  itemIndex: ptt?.treatment,
                }),
                promotion_id: ptt?.product_tile?.title || '',
                promotion_name: ptt?.product_tile?.link?.text || '',
                isVideo: Boolean(ptt?.product_tile?.videoId),
              },
      });
    }
  }, [isPttVisible, ptt]);

  return (
    <article
      className={cn(styles.wrapper, {
        [styles.imageWrapper]: ptt.treatment === Treatment.imageOnly,
      })}
      ref={pttRef}
    >
      {ptt.treatment === Treatment.imageOnly && (
        <PTTAsImage ptt={ptt} isPriority={isPriority} />
      )}
      {ptt.treatment === Treatment.v1 && <PTTOne ptt={ptt} />}
      {ptt.treatment === Treatment.v2 && <PTTTwo ptt={ptt} />}
      {ptt.treatment === Treatment.v3 && <PTTThree ptt={ptt} />}
    </article>
  );
}
